/** AI / stored sessions may use odd casing; counts and filters must match badges. */
export function normalizeImportance(v) {
  const s = String(v ?? '')
    .trim()
    .toLowerCase();
  if (s === 'critical' || s === 'important' || s === 'routine' || s === 'low') return s;
  return 'routine';
}

export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function parseMarkdownToHTML(text) {
  if (!text) return '';
  return text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    .replace(/\n/g, '<br/>');
}

export function getInitial(name) {
  if (!name) return '?';
  return name.charAt(0).toUpperCase();
}

/** Rough HTML → plain text for safe display (not a full sanitizer). */
export function htmlToPlain(html) {
  if (!html) return '';
  return html
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

import { AlertCircle, AlertTriangle, Info, CheckCircle2 } from 'lucide-react';

export const TIER_CONFIG = {
  critical: { label: 'Critical', color: '#ff2d55', icon: AlertCircle },
  important: { label: 'Important', color: '#ff9f0a', icon: AlertTriangle },
  routine: { label: 'Routine', color: '#00f0ff', icon: Info },
  low: { label: 'Low Priority', color: '#636366', icon: CheckCircle2 },
};

export const TIER_ORDER = ['critical', 'important', 'routine', 'low'];
